<template>
  <div v-if="show">
    <div
      v-if="model && isDisabled"
      class="oauth-btn-disabled"
      :aria-label="alt"
      :key="componentKey"
    >
      <img
        v-if="model?.showIcon"
        :src="
          appStore.currentMode() === DisplayMode.Light
            ? providerIconConfiguration.light
            : providerIconConfiguration.dark
        "
        :alt="alt"
      />
      {{ text }} <b>{{ provider }}</b>
    </div>

    <div v-if="model && !isDisabled" class="oauth-btn" :aria-label="alt" :key="componentKey">
      <img
        v-if="model?.showIcon"
        :src="
          appStore.currentMode() === DisplayMode.Light
            ? providerIconConfiguration.light
            : providerIconConfiguration.dark
        "
        class="icon"
        :alt="alt"
      />
      {{ text }}&nbsp;<span class="provider">{{ provider }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import type { ButtonLoginWith } from '../types/configuration/ButtonLoginWith'
import { updateComponentKey } from '../composables/ComponentKey'
import type { OauthOption } from '../types/auth/oauthOption'
//TODO: once Icon is provided as parameter then we can remove imports for all icons here
import googleIconLight from '../assets/icons/light/icon-google.svg'
import googleIconDark from '../assets/icons/dark/icon-google.svg'
import microsoftIconLight from '../assets/icons/light/icon-microsoft.svg'
import microsoftIconDark from '../assets/icons/dark/icon-microsoft.svg'
import salesforceIconLight from '../assets/icons/light/icon-salesforce.svg'
import salesforceIconDark from '../assets/icons/dark/icon-salesforce.svg'
import oktaIconLight from '../assets/icons/light/icon-okta.svg'
import oktaIconDark from '../assets/icons/dark/icon-okta.svg'
import { DisplayMode } from '../types/app/displayMode'
import { useAppStore } from '../stores/appStore'
import type { ProviderIcon } from '../types/auth/ProviderIcon'

const appStore = useAppStore()

const props = defineProps<{
  model: ButtonLoginWith | undefined
  alt: string | undefined
  text: string | undefined
  show: boolean | undefined
  isDisabled: boolean
  provider: OauthOption
}>()

const providerIcons: Record<OauthOption, ProviderIcon> = {
  Google: { light: googleIconLight, dark: googleIconDark },
  Microsoft: { light: microsoftIconLight, dark: microsoftIconDark },
  Salesforce: { light: salesforceIconLight, dark: salesforceIconDark },
  Okta: { light: oktaIconLight, dark: oktaIconDark },
  EmailAndPassword: { light: '', dark: '' },
}

const providerIconConfiguration = computed(() => providerIcons[props.provider] ?? undefined)

const isUrlValid = ref(false)
let componentKey = updateComponentKey(props, () => (isUrlValid.value = props.model !== undefined))
</script>

<style scoped lang="scss">
.oauth-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--border-color);
  border-radius: 12px;
  background: var(--background-color);
  cursor: pointer;
  font-size: 13px;
  height: 34px;
  text-indent: 0px;
}

.oauth-btn .provider,
.oauth-btn strong,
.oauth-btn b {
  font-weight: 700 !important;
}

.icon {
  padding-right: 6px;
}

.oauth-btn-disabled {
  color: #efefef;
}

.oauth-btn:hover {
  background: var(--text-background-color);
}
</style>
